import React, { useRef,useState,useEffect } from 'react';

import '@fontsource/roboto';
import { Grid,Tooltip,Typography } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Countdown from 'react-countdown';
import ReactNoSleep from 'react-no-sleep';

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      //backgroundColor: '#ffbff2',
      //color: 'black',
      maxWidth: 140,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
      textAlign: "center",
    },
  }))(Tooltip);

function GameState(props) {
    const classes = useStyles();

    const currentPlayerADiv = useRef(null)
    const currentPlayerBDiv = useRef(null)

    const [currentTimeIndex, setCurrentTimeIndex ] = useState(0)
    const [currentTime, setCurrentTime] = useState(null);

    const leftPlayerGamePoint = props.leftPlayerGamePoint || 0
    const rightPlayerGamePoint = props.rightPlayerGamePoint || 0
    
    const leftPlayerPoint = props.leftPlayerPoint
    const rightPlayerPoint = props.rightPlayerPoint

    var gameFinished = false
    if (leftPlayerPoint > 10 || rightPlayerPoint > 10) {
        if (Math.abs(leftPlayerPoint - rightPlayerPoint) >= 2){
            gameFinished = true
        }
    }

    var leftServe = false
    if (leftPlayerPoint < 10 || rightPlayerPoint < 10) {
        if ((leftPlayerPoint + rightPlayerPoint) % 4 == 0 || (leftPlayerPoint + rightPlayerPoint) % 4 == 1) {
            leftServe = props.leftPlayerServeFirstThisGame
        }else{
            leftServe = !props.leftPlayerServeFirstThisGame
        }
    }else{
        if ((leftPlayerPoint + rightPlayerPoint) % 2 == 0) {
            leftServe = props.leftPlayerServeFirstThisGame
        }else{
            leftServe = !props.leftPlayerServeFirstThisGame
        }
    }

    const [open, setOpen] = React.useState(true);

    const handleClose = () => {
        setOpen(false)
    };

    const handleOpen = () => {
        setOpen(true)
    };

    useEffect(() => {
        if (true) {
            //setOpen(true)
        }else{
            //setOpen(false)
        }
    })

    const handleLeftPlayerAdd = (e, diff) => {
        if ((e.clientY-currentPlayerADiv.current.offsetTop) > currentPlayerADiv.current.offsetHeight*0.5){
            diff = 0-Math.abs(diff)
        }

        const result = leftPlayerPoint + diff
        if (result < 0) {
            return
        }
        if (diff > 0 && gameFinished) {
            return
        }
        props.setLeftPlayerPoint(result);
        setCurrentTimeIndex(currentTimeIndex + 1);
        setCurrentTime(Date.now()+20000);
    };
    const handleRightPlayerAdd = (e, diff) => {
        if ((e.clientY-currentPlayerADiv.current.offsetTop) > currentPlayerADiv.current.offsetHeight*0.5){
            diff = 0-Math.abs(diff)
        }

        const result = rightPlayerPoint + diff
        if (result < 0) {
            return
        }
        if (diff > 0 && gameFinished) {
            return
        }
        props.setRightPlayerPoint(result);
        setCurrentTimeIndex(currentTimeIndex + 1);
        setCurrentTime(Date.now()+20000);
    };

    const handleLeftPlayerTimeout = () => {
        props.setLeftPlayerTimeout();
    };

    const handleRightPlayerTimeout = () => {
        props.setRightPlayerTimeout();
    };

    const handleRightPlayerServe = () => {
        props.setLeftServeFirst(false)
        setOpen(false)
    }
    const handleLeftPlayerServe = () => {
        props.setLeftServeFirst(true)
        setOpen(false)
    }

    const timeoutRender = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
          return <span className={classes.timeoutNumberFormat}>Timeout</span>
        } else {
          // Render a countdown
          return <span className={classes.timeoutNumberFormat}>{minutes.toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        })}:{seconds.toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        })}</span>;
        }
    };

    

    return (
        <div>
            <Grid container spacing={0} justify="center" direction="row">
                <Grid item>
                    <div className={props.leftPlayerTimeout?classes.timeoutCardActive:classes.timeoutCard} onClick={(e)=>{handleLeftPlayerTimeout()}} >
                        T
                    </div>
                    <HtmlTooltip open={open && props.leftPlayerPoint == 0 && props.rightPlayerPoint == 0 && leftPlayerGamePoint == 0 && rightPlayerGamePoint == 0} onClose={handleClose} onOpen={handleOpen} 
                        placement="top-end"
                        arrow
                        title={
                            <React.Fragment>
                                <Typography color="inherit">Selecciona quien sirve primero</Typography>
                            </React.Fragment>
                        }>
                        <div className={classes.serveFirst} 
                            onClick={(e)=>{handleLeftPlayerServe()}}>{props.leftPlayerServeFirstThisGame && "s"}
                        </div>
                    </HtmlTooltip>
                </Grid>
                <Grid item>
                    <ReactNoSleep>
                        {({ isOn, enable, disable }) => (
                        <div style={{textAlign: "center"}}>
                            <div ref={currentPlayerADiv} 
                                className={classes.gameScore} 
                                onClick={(e)=>{handleLeftPlayerAdd(e,1); if(!isOn){enable()}}}>
                                {leftPlayerPoint}
                            </div>
                        </div>)}
                    </ReactNoSleep>
                </Grid>
                <Grid item spacing={0} justify="center" className={classes.gamePointArea} >
                    <Grid container spacing={0} justify="center" direction="row">
                        <Grid item>
                            <div className={classes.gamePointContainer}>
                                <div className={classes.gamePoint}>
                                    {leftPlayerGamePoint}
                                </div>
                                {leftServe && <div className={classes.serve}>
                                </div>}
                            </div>
                        </Grid>
                        <Grid item>
                            <div className={classes.gamePointContainer}>
                                <div className={classes.gamePoint}>
                                    {rightPlayerGamePoint}
                                </div>
                                {(!leftServe) && <div className={classes.serve}>
                                </div>}
                            </div>
                        </Grid>
                    </Grid>
                    
                    <div className={classes.timeout}>
                        <Countdown  date={currentTime}
                                    key={currentTimeIndex}
                                    renderer={timeoutRender} />
                    </div>
                </Grid>
                <Grid item>
                    <ReactNoSleep>
                        {({ isOn, enable, disable }) => (
                            <div style={{textAlign: "center"}}>
                                <div ref={currentPlayerBDiv} 
                                    className={classes.gameScore} 
                                    onClick={(e)=>{handleRightPlayerAdd(e,1); if(!isOn){enable()}}}>
                                    {rightPlayerPoint}
                                </div>
                            </div>)}
                    </ReactNoSleep>
                </Grid>
                <Grid item>
                    <div className={props.rightPlayerTimeout?classes.timeoutCardActive:classes.timeoutCard} onClick={(e)=>{handleRightPlayerTimeout()}}>
                        T
                    </div>
                    <div className={classes.serveFirst} onClick={(e)=>{handleRightPlayerServe()}}>{!props.leftPlayerServeFirstThisGame && "s"}</div>
                </Grid>
            </Grid>
        </div>
    );
}

export default GameState;

const useStyles = makeStyles((theme) => ({
    gameScore: {
        background: "linear-gradient(0deg, #ff50c2 50%, #ff4092 50%)", //"#ff4092",
        color: "white",
        width: "28vw",
        fontSize: "20vw",
        fontWeight: "bold",
        textAlign: "center",
        paddingTop: "3vw",
        paddingBottom: "3vw",
        marginLeft: "2px",
        marginRight: "2px",
        [theme.breakpoints.up('sm')]: {
            width: "120px",
            fontSize: "90px",
            paddingTop: "10px",
            paddingBottom: "10px",
        },
        [theme.breakpoints.up('md')]: {
            width: "240px",
            fontSize: "180px",
            paddingTop: "20px",
            paddingBottom: "20px",
        },
    },
    serve: {
        marginLeft: "1vw",
        marginTop: "5px",
        width: "3vw",
        height: "3vw",
        borderRadius: "2vw",
        borderColor: "#FFA5C0",
        borderStyle: "solid",
        borderWidth: "1px",
        backgroundColor: "#FFA500",
        textAlign:"center",
        [theme.breakpoints.up('sm')]: {
            width: "20px",
            marginLeft: "6px",
            height: "20px",
            borderRadius: "20px",
        },
        [theme.breakpoints.up('md')]: {
            width: "40px",
            marginLeft: "12px",
            height: "40px",
            borderRadius: "40px",
        },
    },
    serveFirst: {
        backgroundColor: "white",
        borderColor: "#ff4092",
        borderStyle: "solid",
        borderWidth: "1px",
        color: "black",
        width: "7vw",
        height: "8vw",
        fontSize: "6vw",
        fontWeight: "bold",
        textAlign: "center",
        marginLeft: "2px",
        marginRight: "2px",
        marginTop: "1vw",
        [theme.breakpoints.up('sm')]: {
            width: "27px",
            height: "28px",
            fontSize: "20px",
            marginTop: "30px"
        },
        [theme.breakpoints.up('md')]: {
            width: "54px",
            height: "56px",
            fontSize: "40px",
            marginTop: "60px"
        },
    },
    gamePoint:{
        backgroundColor: "black",
        width: "5vw",
        fontSize: "4vw",
        fontWeight: "bold",
        color: "white",
        textAlign: "center",
        paddingTop: "5px",
        paddingBottom: "5px",
        marginLeft: "2px",
        marginRight: "2px",
        [theme.breakpoints.up('sm')]: {
            width: "30px",
            fontSize: "20px",
            paddingTop: "6px",
            paddingBottom: "6px",
        },
        [theme.breakpoints.up('md')]: {
            width: "60px",
            fontSize: "40px",
            paddingTop: "12px",
            paddingBottom: "12px",
        },
    },
    gamePointContainer: {
        textAlign: "center",
    },
    gamePointArea: {
        width: "13vw",
        textAlign: "center",
        [theme.breakpoints.up('sm')]: {
            width: "70px",
        },
        [theme.breakpoints.up('md')]: {
            width: "140px",
        },
    },
    timeoutNumberFormat:{
        
    },
    timeout: {
        fontSize: "80%",
        marginTop: "20px"
    },
    timeoutCardActive: {
        backgroundColor: "#ff4092",
        color: "white",
        width: "8vw",
        fontSize: "6vw",
        fontWeight: "bold",
        textAlign: "center",
        paddingTop: "6px",
        paddingBottom: "6px",
        marginLeft: "2px",
        marginRight: "2px",
        [theme.breakpoints.up('sm')]: {
            width: "30px",
            fontSize: "20px"
        },
        [theme.breakpoints.up('md')]: {
            width: "60px",
            fontSize: "40px"
        },
    },
    timeoutCard: {
        backgroundColor: "#ff4092",
        color: "#ff4092",
        width: "8vw",
        fontSize: "6vw",
        fontWeight: "bold",
        textAlign: "center",
        paddingTop: "6px",
        paddingBottom: "6px",
        marginLeft: "2px",
        marginRight: "2px",
        [theme.breakpoints.up('sm')]: {
            width: "30px",
            fontSize: "20px"
        },
        [theme.breakpoints.up('md')]: {
            width: "60px",
            fontSize: "40px"
        },
    }
  }));

